import type { FilterSectionConfig } from "@/shared/components/common/ListFilterPopover";
import { TENANT_USER_ACCOUNT_STATUS_OPTIONS } from "@/features/tenantUsers/constants";

/** Only filters the `GET api/v1/users` endpoint supports are offered here. */
export function getContentCreatorsListFilterSections(
  t: (key: string) => string,
): FilterSectionConfig[] {
  return [
    {
      key: "accountStatus",
      label: t("contentCreators:filter.accountStatus"),
      options: [...TENANT_USER_ACCOUNT_STATUS_OPTIONS],
      optionsClassName: "grid grid-cols-1 gap-2",
      type: "radio",
    },
  ];
}
